<template>
  <div class="bg-offWhite h-4/5 lg:h-full overflow-x-auto">
    <ul class="flex flex-col m-none p-none list-none h-full overflow-auto">
      <li class="flex justify-center items-center p-twentyFive">
        <ButtonLink
          :to="envelopeCreate"
          data-test="new_envelope_button"
          data-ec="side_menu"
          data-et="new_envelope_button"
        >
          <FontIcon
            name="plus"
            class="mr-base"
          />
          <span>{{ $t('navigation.buttons.newEnvelope') }}</span>
        </ButtonLink>
      </li>
      <div>
        <li
          v-bind:key="index"
          class="outline-none bg-opacity-25 hover:bg-sideMenuHover break-all hover:bg-opacity-25 border-l-0 border-t-0 first-of-type:border-t-1 border-r-0 border-b-1 border-sideMenuHover border-solid border-opacity-25"
          :class="{'bg-sideMenuHover': menuItemIsActive(item)}"
          v-for="(item, index) in enabledMenuItems"
          data-ec="side_menu"
          :data-test="`${item.name}_button`"
          :data-et="`${item.name}_button`"
          :data-testid="`menu-side-${item.name}-btn`">
          <RouterLink
            class="p-base w-full outline-none menu-item-transition font-medium text-md inline-flex items-center menuItemHeight cursor-pointer text-black no-underline"
            :class="{'focus:bg-sideMenuHover focus:bg-opacity-25' : !menuItemIsActive(item)}"
            :to="item.route">
            <div
              :class="{'bg-primary bg-opacity-100': menuItemIsActive(item)}"
              class="ml-base p-sm mr-sm bg-sideMenuHover bg-opacity-25 rounded-full w-lg h-lg flex items-center justify-center">
              <FontIcon
                :class="menuItemIsActive(item) ? 'text-whiteOverride' : 'text-placeholderGray'"
                :name="item.listItemIcon"
              />
            </div>
            <span
              :class="menuItemIsActive(item) ? 'font-normal' : 'font-light'">
              {{ item.title }}
            </span>
          </RouterLink>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import FontIcon from '@/components/Icon.vue';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SignableSideMenu',
  components: {
    ButtonLink,
    FontIcon,
  },
  data() {
    return {
      menuItems: [
        {
          title: this.$t('navigation.envelopes'),
          name: 'envelopes',
          route: '/',
          exact: true,
          listItemIcon: 'home',
          inverted: true,
          ec: 'sidenav',
          et: 'envelopes',
          roles: [],
        },
        {
          title: this.$t('navigation.templates'),
          name: 'templates',
          route: '/templates',
          listItemIcon: 'file-text',
          inverted: true,
          ec: 'sidenav',
          et: 'templates',
          roles: [],
        },
        {
          title: this.$t('navigation.bulkSend'),
          name: 'bulk-send',
          route: '/bulk-send',
          listItemIcon: 'layer-group',
          inverted: true,
          ec: 'sidenav',
          et: 'bulk-send',
          roles: [],
        },
        {
          title: this.$t('navigation.contacts'),
          name: 'contacts',
          route: '/contacts',
          listItemIcon: 'address-book',
          inverted: true,
          ec: 'sidenav',
          et: 'contacts',
          roles: [],
        },
        {
          title: this.$t('navigation.branding'),
          name: 'branding',
          route: '/branding',
          listItemIcon: 'paint-brush',
          inverted: true,
          ec: 'sidenav',
          et: 'branding',
          roles: [],
        },
        {
          title: this.$t('navigation.usersAndTeams'),
          name: 'users',
          route: '/users',
          listItemIcon: 'users',
          inverted: true,
          ec: 'sidenav',
          et: 'users_and_teams',
          roles: [],
        },
        {
          title: this.$t('navigation.integrations'), name: 'slack', route: '/integrations', alternateRoute: '/company-settings/integrations', listItemIcon: 'plug', inverted: true, roles: ['super-admin'],
        },
      ],
    };
  },
  methods: {
    menuItemIsActive(item) {
      if (item.route === '/') {
        return this.$route.path === '/envelopes';
      }
      const pathMatchesRoute = (item.route === this.$route.path) || (item?.alternateRoute === this.$route.path);
      const pathStartsWithRouteAndIsNotHome = !!(this.$route.path.startsWith(item.route) && item.route !== '/');

      return !!(pathMatchesRoute || pathStartsWithRouteAndIsNotHome);
    },
  },
  computed: {
    ...mapGetters({
      userHasRole: 'roles/userHasRole',
      featureEnabled: 'featureFlags/featureEnabled',
    }),

    // Return a list of the menu items the current user has permission to see.
    enabledMenuItems() {
      return this.menuItems.filter(menuItem =>
        // If there are no roles defined or if there are roles ensure the user has the correct role
         !menuItem.roles.length || this.userHasRole(menuItem.roles));
    },
    envelopeCreate() {
      return this.featureEnabled('new-envelope-flow') ? { name: 'EnvelopesCreate' } : { name: 'EnvelopeInstantiate' };
    },
  },
};
</script>

